import StyledButton from "../../components/styled/StyledButton";
import {
  ForgotPasswordFormData,
  ForgotPasswordSchema,
} from "../../types/forms/auth/forgotPasswordData.form";
import { useForgotPassword } from "../../api/auth.api";
import ArrowLeft from "../../assets/icons/arrow-left.svg?react";
import { useLocation, useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";

const ForgotPasswordConfirmationPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { email } = state;
  const [countdown, setCountdown] = useState(0);

  const { mutate } = useForgotPassword();

  const { handleSubmit } = useForm<ForgotPasswordFormData>({
    resolver: zodResolver(ForgotPasswordSchema),
    defaultValues: { email },
  });

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [countdown]);

  const onSubmit = (data: ForgotPasswordFormData) => {
    if (countdown === 0) {
      mutate(data);
      setCountdown(60);
    }
  };

  return (
    <div className="bg-brand600 flex min-h-screen w-screen items-center justify-center">
      <div className="mx-4 flex flex-col items-center gap-4 rounded-2xl bg-white px-6 py-6 md:min-h-[500px] md:min-w-[600px] md:gap-16 md:px-16 md:py-12">
        <img src="/images/pelican-logo.png" className="h-32 w-32" />
        <div className="flex flex-col items-center gap-3">
          <h1 className="text-center text-3xl font-medium text-black">Vérifiez vos emails</h1>
          <p className="text-center text-sm text-gray-600">
            Nous avons envoyé un lien de réinitialisation du mot de passe à l’adresse email {email}
          </p>
        </div>

        <p>Vous n’avez rien reçu ?</p>

        <div className="flex w-full flex-col gap-2">
          <StyledButton onClick={handleSubmit(onSubmit)} disabled={countdown > 0}>
            {countdown > 0 ? (
              <div className="flex flex-row items-center justify-center gap-4">{countdown}</div>
            ) : (
              "Renvoyer"
            )}
          </StyledButton>
          <StyledButton mode="secondary" onClick={() => navigate("/login")}>
            <div className="gap flex items-center justify-center gap-2">
              <ArrowLeft />
              Retour à la connexion
            </div>
          </StyledButton>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordConfirmationPage;
